import duplicateLuckyDraws  from "./duplicateLuckyDraws.api";

const optionsApi = {
  duplicateLuckyDraws
};

export default optionsApi;
